import React from "react";
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../contexts/LanguageContext';

export default function Footer() {
  const { t } = useTranslation();
  const { isRTL: _isRTL } = useLanguage();
  
  return (
    <>
      <footer
        className="section section--full-width footer"
        style={{
          display: "block",
          padding: "20px 0",
          margin: "0px",
          backgroundPosition: "100% 100%",
          width: "100%",
          backgroundColor: "rgb(255, 255, 255)",
          position: "relative",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          maxWidth: "100%",
          borderTop: "1px solid rgba(0, 0, 0, 0.1)",
        }}
      >
        <div
          className="container container--large"
          style={{
            width: "100%",
            boxSizing: "border-box",
            maxWidth: "1200px",
            margin: "0px auto",
            padding: "0 clamp(15px, 4vw, 20px)",
          }}
        >
          <div
            className="footer_bottom"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "20px",
              minHeight: "60px",
            }}
          >
            {/* Logo */}
            <div
              className="footer_logo"
              style={{ 
                order: 1,
                display: "flex",
                alignItems: "center",
              }}
            >
              <img 
                src="/logo_balck.png" 
                alt="Al Mikial Law Firm" 
                style={{
                  height: "clamp(30px, 4vw, 40px)",
                  width: "auto",
                  objectFit: "contain"
                }}
              />
            </div>

            {/* Contact Info */}
            <div
              className="footer_contact"
              style={{
                order: 2,
                fontSize: "clamp(12px, 2vw, 14px)",
                color: "rgba(0, 0, 0, 0.7)",
                textAlign: "center",
                lineHeight: "1.4",
              }}
            >
              <div>Email: info@almikial.com.sa</div>
              <div>Phone: +966 11 222 3311</div>
              <div style={{ marginTop: "4px" }}>
                <a
                  href="https://maps.app.goo.gl/w9noVjCEanJBkPTW6"
                  target="_blank"
                  rel="noopener noreferrer"
                  title={t('common.viewOnMap')}
                  style={{
                    color: "rgba(0, 0, 0, 0.7)",
                    textDecoration: "none",
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    transition: "color 0.2s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "rgba(0, 0, 0, 0.9)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "rgba(0, 0, 0, 0.7)";
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }} aria-hidden="true">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  {t('common.location')}: {t('common.viewOnMap')}
                </a>
              </div>
            </div>

            {/* Copyright */}
            <div
              className="footer_copyright"
              style={{
                order: 3,
                fontSize: "clamp(12px, 2vw, 14px)",
                color: "rgba(0, 0, 0, 0.7)",
                textAlign: "center",
                lineHeight: "1.4",
              }}
            >
              {t('footer.copyright')}
            </div>

            {/* Social Icons */}
            <div
              className="footer_icons"
              style={{
                order: 4,
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <a
                className="footer_icon svg-icon svg-icon--linkedin"
                href="https://linkedin.com/company/almikial-law-firm"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  backgroundColor: "transparent",
                  textDecoration: "none",
                  color: "inherit",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "clamp(32px, 5vw, 40px)",
                  height: "clamp(32px, 5vw, 40px)",
                  borderRadius: "0px",
                  padding: "0px",
                  margin: "0px",
                  position: "relative",
                  transition: "transform 0.3s ease",
                  minWidth: "32px",
                  minHeight: "32px",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.1)"
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)"
                }}
              >
                <svg
                  focusable="false"
                  viewBox="0 0 24 24"
                  style={{
                    overflow: "visible",
                    width: "100%",
                    height: "100%",
                  }}
                >
                  <title>LinkedIn</title>
                  <text
                    x="12"
                    y="16"
                    textAnchor="middle"
                    fontSize="16"
                    fontFamily="Arial, sans-serif"
                    fontWeight="bold"
                    fill="#000000"
                  >
                    in
                  </text>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </footer>
      
      <style>{`
        /* Mobile footer adjustments - keep items in one line */
        @media (max-width: 768px) {
          .footer_bottom {
            flex-direction: row !important;
            justify-content: space-between !important;
            align-items: center !important;
            gap: 5px !important;
            padding: 0 5px !important;
          }
          
          .footer_logo {
            order: 1 !important;
            flex-shrink: 0 !important;
          }
          
          .footer_logo img {
            height: 20px !important;
          }
          
          .footer_contact {
            order: 2 !important;
            font-size: 9px !important;
            line-height: 1.2 !important;
            text-align: left !important;
            flex: 1 !important;
            margin: 0 5px !important;
          }
          
          .footer_copyright {
            order: 3 !important;
            font-size: 9px !important;
            text-align: center !important;
            flex: 1 !important;
            white-space: nowrap !important;
            overflow: hidden !important;
            text-overflow: ellipsis !important;
          }
          
          .footer_icons {
            order: 4 !important;
            justify-content: flex-end !important;
            flex-shrink: 0 !important;
          }
          
          .footer_icons a {
            width: 20px !important;
            height: 20px !important;
            min-width: 20px !important;
            min-height: 20px !important;
          }
          
          .footer_icons svg text {
            font-size: 10px !important;
          }
        }
        
        /* Tablet footer adjustments */
        @media (min-width: 769px) and (max-width: 1024px) {
          .footer_bottom {
            gap: 15px !important;
          }
        }
      `}</style>
      
      {/* Global CSS reset moved to index.css for security */}
    </>
  );
}